import React, { useState } from 'react'
import { Typography, Button, Box, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import CustomAlert from '../userlocationcomponents/CustomAlert';
import { mandatoryFields } from '../../redux/actions/assetActions';

const BottomButtons = ({ page = '', buttonAttributes, enableAuthorizeButton = false, saveButton = false, saveClick, params, authorizeButton = false, authorizeClick, continueButton = true, disableContineButton = false, isDataChanged, notUpdateRedux }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const assetCategoryType = useSelector((state) => state?.serviceType?.assetType);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const findPageName = buttonAttributes.find((item) => item.currentPageName === page);
  const { setPage,
    cancelButtonName,
    continueButtonName,
    backButtonName,
    backButton, nextPageName, previousPageName, currentPageName } = findPageName;

  const handleCloseCancelDialog = () => {
    setShowDeleteDialog(false);
  };

  const handleConfirmCancel = async () => {
    setShowDeleteDialog(false);
    navigate(`${assetCategoryType}`);
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

  };

  const handleBackClick = () => {
    setPage(previousPageName);
    dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

  };


  const handleCancelClick = () => {
    if (isDataChanged) {
      setShowDeleteDialog(true);
    } else {
      setShowDeleteDialog(false);
      if (!assetCategoryType) {
        const url = window.location.pathname;
        const urlArray = url.split("/");
        if (urlArray?.includes('assetsFEM')) {
          navigate('/assetsFEM');
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

        } else if (urlArray?.includes('assetsBEM')) {
          navigate('/assetsBEM');
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));

        }
      } else {
        navigate(`${assetCategoryType}`);
      }
    }
  };


  return (<>
    <Box pt={{ xs: 3, md: 8 }} sx={{ display: 'flex', justifyContent: 'space-between' }} flexWrap={'wrap'}>

      {backButton && <Box><IconButton aria-label="previous" onClick={handleBackClick} >
        <ArrowBackIcon />
      </IconButton>
        <Typography variant='labelSm' color={'text.primary'}>{backButtonName}</Typography></Box>}


      <Box sx={{ display: 'inline-flex', gap: 2 }}>
        {saveButton ? <Button variant='contained' onClick={saveClick}>Save</Button> : ''}
        <Button variant='outlined' onClick={handleCancelClick}>{cancelButtonName}</Button>
        {authorizeButton ? <Button variant='contained' disabled={enableAuthorizeButton} onClick={authorizeClick} >{continueButtonName}</Button> : continueButton ? <Button disabled={disableContineButton} variant='contained' type="submit">{continueButtonName}</Button> : ''}</Box>

    </Box>
    <CustomAlert
      open={showDeleteDialog}
      onClose={handleCloseCancelDialog}
      onConfirm={handleConfirmCancel}
      content={`Record(s) not Saved/Updated. Do you want to continue?`}
      confirmBtn={'Yes'}
      cancelBtn={'No'}
    />
  </>
  )
}

export default BottomButtons